"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const Button_1 = require("./Button");
const ButtonGroup = ({ children, onChange, activeId }) => {
    var _a, _b, _c;
    const items = Array.isArray(children) ? children : [children];
    const [activeKey, setActiveKey] = (0, react_2.useState)((_c = (_b = (_a = items === null || items === void 0 ? void 0 : items[0]) === null || _a === void 0 ? void 0 : _a.key) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "");
    (0, react_2.useEffect)(() => {
        if (activeId)
            setActiveKey(activeId);
    }, [activeId]);
    (0, react_2.useEffect)(() => {
        if (onChange)
            onChange(activeKey);
    }, [activeKey]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "btn-group w-100", role: "group", "aria-label": "Basic example", children: items.map((item, index) => {
            return (0, react_1.createElement)(Button_1.Button, Object.assign({}, item.props, { active: activeKey === item.key, key: item.key, onPress: () => { var _a, _b; return setActiveKey((_b = (_a = item === null || item === void 0 ? void 0 : item.key) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ""); } }));
        }) }));
};
exports.ButtonGroup = ButtonGroup;
